import React, { useEffect, useState } from "react";
import customHttp from "../../services/customHTTP";
import { Box, IconButton, Tooltip, CircularProgress } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { AddCircle, ChevronLeft, ChevronRight, Delete } from "@mui/icons-material";
import Datagrid from "../Datagrid/Datagrid";
const ManageSitesMaster = () => {
	const [allSites, setAllSites] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState("");

	useEffect(() => {
		const fetchAllSites = async () => {
			try {
				const response = await customHttp.get("/cus_sites/getsites");
				console.log(response.data.data);
				setAllSites(response.data.data);
			} catch (error) {
				setError(error.message);
			} finally {
				setLoading(false);
			}
		};
		fetchAllSites();
	}, []);

	const handleEdit = (site) => {
		console.log(site);
	};

	const columns = [
		{ field: "customer_site_number", headerName: "Site Number", flex: 1 },
		{ field: "customer_site_name", headerName: "Site Name", flex: 1 },
		{ field: "invoice_account", headerName: "Invoice Account", flex: 1 },
		{ field: "parent_customer", headerName: "Parent Customer", flex: 1 },
		{ field: "customer_site_address_full_lnnumber", headerName: "Site Address", flex: 1 },
		{
			headerName: "Actions",
			sortable: false,
			width: 100, // Ensure there's enough space for icons
			headerAlign: "center",
			align: "left",
			renderCell: (params) => (
				<div>
					<Tooltip title="Edit User">
						<IconButton
							color="primary"
							aria-label="Edit User"
							onClick={(event) => {
								event.stopPropagation();
								handleEdit(params.row);
							}}>
							<EditIcon />
						</IconButton>
					</Tooltip>
				</div>
			),
		},
	];

	const customButtons = [
		{
			label: "Upload New Sites",
			icon: <AddCircle />,
			onClick: () => {
				console.log("Upload New Sites");
			},
		},
		{
			label: "Delete Selected",
			icon: <Delete />,
			onClick: () => {},
		},
	];

	if (loading) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "40vh" }}>
				<CircularProgress />
			</Box>
		);
	}

	return (
		<div>
			<Datagrid
				loading={loading}
				data={allSites}
				columns={columns}
				customButtons={customButtons}
				checkboxSelection={true}
				rowIdField="site_id"
				sortBy={[{ field: "site_id", sort: "asc" }]}
			/>
		</div>
	);
};

export default ManageSitesMaster;
